import rootRoute from '@input-web/configs/route/route.root';
import { createRoute } from '@tanstack/react-router';
import MainErrorView from './main.error-view';
import MainView from './main.view';

const mainRoute = createRoute({
  component: MainView,
  errorComponent: MainErrorView,
  getParentRoute: () => rootRoute,
  path: '/',
});

export default mainRoute;
